import { useEffect } from 'react';
import { useUserStore } from '../../../Auth/stores/authStore';
import { getUserByExternalId } from '../../queries/auth';

let fetchPromise: Promise<string> | null = null;

const useUserMemory = () => {
  const { user, setUser } = useUserStore();
  const memoryUserUuid = user?.memoryUserUuid;

  const fetchUser = async () => {
    if (!user?.id || memoryUserUuid) return;

    if (fetchPromise) {
      await fetchPromise;
      return;
    }

    try {
      fetchPromise = getUserByExternalId(user.id);
      const userUuid = await fetchPromise;
      setUser({ ...user, memoryUserUuid: userUuid });
    } catch (error) {
      console.error(error);
    } finally {
      fetchPromise = null;
    }
  };

  useEffect(() => {
    if (!memoryUserUuid && user?.id) fetchUser();
  }, [user, memoryUserUuid]);

  return { memoryUserUuid, fetchUserMemory: fetchUser };
};

export default useUserMemory;
